import { api } from '@/api/client';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useDeleteTaxRate() {
  const queryClient = useQueryClient();
  return useMutation<void, Error, string>({
    mutationFn: async id => {
      await api.delete<void>(`/api/v1/payroll/tax-rates/${id}`);
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['payroll', 'tax-rates'] });
    },
  });
}
